import { render, staticRenderFns } from "./MoveConfirmation.vue?vue&type=template&id=61902fd6&"
import script from "./MoveConfirmation.vue?vue&type=script&lang=js&"
export * from "./MoveConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./MoveConfirmation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src781945140/src/BedBoard.Sdk.Receiver/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('61902fd6', component.options)
    } else {
      api.reload('61902fd6', component.options)
    }
    module.hot.accept("./MoveConfirmation.vue?vue&type=template&id=61902fd6&", function () {
      api.rerender('61902fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MoveConfirmation.vue"
export default component.exports